import { ENTITY_ACTION_TYPE, ENTITY_EVENT_TYPES, EVENT_TYPE } from "../constants";

export function getEventType(entityEvent) {
    return entityEvent?.type;
}

export function isEventTypeCreate(entityEvent) {
    return getEventType(entityEvent) === EVENT_TYPE.CREATED;
}

export function getEntityEventType(entityEvent) {
    return entityEvent?.eventEntityType;
}

export function getEntityEventActionType(entityEvent) {
    return entityEvent?.action;
}

export function getEntityEventFrontendData(entityEvent) {
    return entityEvent?.frontendData;
}

export function getEntityEventEntity(entityEvent) {
    return getEntityEventFrontendData(entityEvent)?.entity;
}

export function getEntityEventEmail(entityEvent) {
    return getEntityEventType(entityEvent) === ENTITY_EVENT_TYPES.EMAIL_NOTIFICATION && getEntityEventEntity(entityEvent);
}

export function getEntityEventSMS(entityEvent) {
    return getEntityEventType(entityEvent) === ENTITY_EVENT_TYPES.SMS_NOTIFICATION && getEntityEventEntity(entityEvent);
}

export function getEntityEventComment(entityEvent) {
    return getEntityEventActionType(entityEvent) === ENTITY_ACTION_TYPE.RETURN_CREATE_COMMENT && getEntityEventFrontendData(entityEvent)?.description;
}
